import React, { useEffect, useState } from 'react'

import { stripePromise } from '../../utils/common'
import { getTrialExpiredCheckout } from '../../utils/Checkout'

function CheckoutButton({siteId, title, size, className, overrideCancelUrl, performClick, style }) {

    const [state, setState] = useState({
        redirect: false
    })

    useEffect(() => {
        if(performClick){
            handleClick()
        }
    }, [performClick])

    const { redirect } = state

    const handleClick = async (event) => {
        await setState(prevState => ({
            ...prevState,
            redirect: true
        }))
        const { response } = await getTrialExpiredCheckout(siteId, overrideCancelUrl)

        const stripe = await stripePromise;
        const { error } = await stripe.redirectToCheckout({
            sessionId: response.sessionId
        });
        
        await setState(prevState => ({
            ...prevState,
            redirect: false
        }))
    };

    return (
        <button role="link" className={`btn btn-${size} btn-primary ${className}`} onClick={handleClick} style={style}>
            {redirect && <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>}
            {title}
        </button>
    );
}

CheckoutButton.defaultProps = {
    title: "Checkout",
    overrideCancelUrl: null,
    performClick: false,
    size: "lg",
    style: {},
    className: ""
}

export default CheckoutButton